interface PriorityPostageInputProps {
  isDirty: boolean;
  isEditingEnabled: boolean;
  value: string;
  id: any;
  mailingType: string;
  packageType: string;
  onInputChange: (e: any, id: number, packageType: string, mailingDestinationType: string) => void;
}
const PostageRateInput: React.FC<PriorityPostageInputProps> = ({
  isDirty,
  isEditingEnabled,
  value,
  id,
  mailingType,
  packageType,
  onInputChange,
}) => {
  return (
    <input
      style={{
        height: '2.5rem',
        borderRadius: '0.3125rem',
        textAlign: 'right',
        border: '0.0625rem solid #7e828b',
        backgroundColor: isDirty ? '#ffeedf' : '#f6f6f6',
        borderColor: isDirty ? '#7b3f07' : '',
        color: isEditingEnabled ? '' : '#7e828b',
        width: '95%',
      }}
      onChange={(e) => onInputChange(e, Number(id), packageType, mailingType)}
      value={value}
      id={id}
      disabled={!isEditingEnabled}
    />
  );
};

export default PostageRateInput;
